var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlanco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 44.807,
    viewBox: "0 0 120 44.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_19",
    "data-name": "Rect\xE1ngulo 19",
    width: 120,
    height: 44.807,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_256",
    "data-name": "Grupo 256",
    transform: "translate(3288 484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(-3288 -484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M21.644,65.766a1.854,1.854,0,0,1-.513.661,2.308,2.308,0,0,1-.784.409,3.411,3.411,0,0,1-1.01.141,4.514,4.514,0,0,1-1.527-.268,4.039,4.039,0,0,1-1.361-.822l.885-1.06a4.434,4.434,0,0,0,.958.6,2.561,2.561,0,0,0,1.075.224,1.309,1.309,0,0,0,.724-.17.536.536,0,0,0,.258-.472v-.02a.585.585,0,0,0-.054-.258.531.531,0,0,0-.2-.209,2.146,2.146,0,0,0-.419-.195,7.215,7.215,0,0,0-.7-.2,8.517,8.517,0,0,1-.936-.281,2.652,2.652,0,0,1-.712-.385,1.548,1.548,0,0,1-.453-.569,1.967,1.967,0,0,1-.161-.846v-.02a1.977,1.977,0,0,1,.174-.841,1.918,1.918,0,0,1,.488-.647,2.18,2.18,0,0,1,.75-.418,3.008,3.008,0,0,1,.962-.146,4.066,4.066,0,0,1,1.376.224,4.006,4.006,0,0,1,1.153.642l-.778,1.128a4.981,4.981,0,0,0-.895-.491,2.293,2.293,0,0,0-.875-.18,1.06,1.06,0,0,0-.657.171.516.516,0,0,0-.219.423v.02a.611.611,0,0,0,.063.287.581.581,0,0,0,.229.219,2.185,2.185,0,0,0,.453.185q.288.088.727.2a7.082,7.082,0,0,1,.922.307,2.559,2.559,0,0,1,.683.409,1.559,1.559,0,0,1,.419.559,1.9,1.9,0,0,1,.141.768v.02a2.11,2.11,0,0,1-.183.9",
    transform: "translate(-6.091 -22.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M32.39,66.937V62.491L30.474,65.4h-.038l-1.9-2.879v4.416H27.06V60.128h1.615l1.79,2.879,1.79-2.879h1.615v6.808Z",
    transform: "translate(-10.02 -22.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M45.19,66.908l-.622-1.527H41.689l-.622,1.527H39.539l2.918-6.857h1.381l2.918,6.857ZM43.128,61.85l-.9,2.208h1.809Z",
    transform: "translate(-14.641 -22.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M56.8,66.936l-1.459-2.178H54.166v2.178h-1.5V60.128h3.113a2.774,2.774,0,0,1,1.892.594,2.084,2.084,0,0,1,.676,1.653v.02a2.134,2.134,0,0,1-.4,1.347,2.339,2.339,0,0,1-1.055.764l1.663,2.431Zm.029-4.484a.871.871,0,0,0-.311-.73,1.377,1.377,0,0,0-.866-.242H54.166v1.955h1.518a1.243,1.243,0,0,0,.851-.263.889.889,0,0,0,.3-.7Z",
    transform: "translate(-19.503 -22.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M66.633,61.509v5.427h-1.5V61.509H63.064V60.128H68.7v1.381Z",
    transform: "translate(-23.352 -22.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M82.772,67l-.788-.8a3.791,3.791,0,0,1-.909.55,2.745,2.745,0,0,1-1.084.209,2.9,2.9,0,0,1-.9-.136,2.146,2.146,0,0,1-.725-.394,1.855,1.855,0,0,1-.482-.623,1.876,1.876,0,0,1-.175-.822,1.839,1.839,0,0,1,.341-1.123,2.437,2.437,0,0,1,.982-.754,2.767,2.767,0,0,1-.365-.686,2.088,2.088,0,0,1-.112-.686,1.738,1.738,0,0,1,.136-.676,1.661,1.661,0,0,1,.4-.574,1.977,1.977,0,0,1,.647-.4,2.4,2.4,0,0,1,.88-.15,2.233,2.233,0,0,1,.788.132,1.825,1.825,0,0,1,.6.365,1.6,1.6,0,0,1,.389.55,1.689,1.689,0,0,1,.136.676,1.575,1.575,0,0,1-.4,1.118,2.71,2.71,0,0,1-1.031.671l.9.9c.11-.175.22-.361.331-.559s.22-.4.331-.608l1.1.6q-.195.361-.418.73t-.477.71l1,1Zm-2.927-2.975a1.181,1.181,0,0,0-.486.413.925.925,0,0,0-.146.491.721.721,0,0,0,.268.589,1.046,1.046,0,0,0,.686.219,1.293,1.293,0,0,0,.5-.1,1.973,1.973,0,0,0,.482-.287Zm1.2-2.753a.657.657,0,0,0-.462-.166.626.626,0,0,0-.482.2.716.716,0,0,0-.179.506.952.952,0,0,0,.092.423,2.06,2.06,0,0,0,.307.433A2.062,2.062,0,0,0,81,62.292a.7.7,0,0,0,.229-.54.616.616,0,0,0-.179-.477",
    transform: "translate(-28.774 -22.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M95.359,61.48v1.468h3.249V64.3H95.359v2.636h-1.5V60.128h5.184V61.48Z",
    transform: "translate(-34.756 -22.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M108.127,66.936l-1.459-2.178h-1.177v2.178h-1.5V60.128h3.113a2.774,2.774,0,0,1,1.892.594,2.084,2.084,0,0,1,.676,1.653v.02a2.134,2.134,0,0,1-.4,1.347,2.339,2.339,0,0,1-1.055.764l1.663,2.431Zm.029-4.484a.871.871,0,0,0-.311-.73,1.377,1.377,0,0,0-.866-.242h-1.488v1.955h1.518a1.243,1.243,0,0,0,.851-.263.889.889,0,0,0,.3-.7Z",
    transform: "translate(-38.508 -22.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_18",
    "data-name": "Rect\xE1ngulo 18",
    width: 1.498,
    height: 6.808,
    transform: "translate(72.586 37.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M120.35,66.937V60.128h5.126v1.332h-3.647v1.381h3.21v1.332h-3.21V65.6h3.7v1.332Z",
    transform: "translate(-44.565 -22.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M135.475,66.937l-3.3-4.328v4.328H130.7V60.128h1.381l3.19,4.192V60.128h1.479v6.808Z",
    transform: "translate(-48.397 -22.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M148.911,64.874a3.162,3.162,0,0,1-.744,1.079,3.524,3.524,0,0,1-1.147.72,3.962,3.962,0,0,1-1.464.263H142.9V60.128h2.655a4.04,4.04,0,0,1,1.464.258,3.461,3.461,0,0,1,1.147.715,3.185,3.185,0,0,1,.744,1.074,3.383,3.383,0,0,1,.263,1.337v.02a3.416,3.416,0,0,1-.263,1.342m-1.3-1.342a2.224,2.224,0,0,0-.151-.827,1.933,1.933,0,0,0-.419-.652,1.855,1.855,0,0,0-.647-.423,2.238,2.238,0,0,0-.836-.15H144.4v4.1h1.157a2.3,2.3,0,0,0,.836-.146,1.793,1.793,0,0,0,.647-.418,1.966,1.966,0,0,0,.419-.642,2.18,2.18,0,0,0,.151-.827Z",
    transform: "translate(-52.915 -22.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M154.979,66.937V60.128h1.5v5.456h3.394v1.352Z",
    transform: "translate(-57.388 -22.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M167.542,64.223v2.713h-1.5V64.252l-2.616-4.124h1.751l1.624,2.733,1.654-2.733h1.7Z",
    transform: "translate(-60.516 -22.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M15.1,30.21A15.105,15.105,0,1,1,30.21,15.1,15.107,15.107,0,0,1,15.1,30.21m0-24.944A9.839,9.839,0,1,0,24.943,15.1,9.851,9.851,0,0,0,15.1,5.266",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M116.749,30.056a2.57,2.57,0,0,1-1.734-.694L95.526,12.176V27.439a2.617,2.617,0,0,1-5.235,0V6.373a2.611,2.611,0,0,1,2.618-2.617,2.539,2.539,0,0,1,1.734.662l19.488,17.218V6.373a2.617,2.617,0,0,1,5.235,0V27.439a2.63,2.63,0,0,1-1.545,2.4,2.416,2.416,0,0,1-1.072.221",
    transform: "translate(-33.434 -1.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M78.958,30.056a2.57,2.57,0,0,1-1.734-.694L57.767,12.176V27.439a2.617,2.617,0,0,1-5.235,0V6.373A2.611,2.611,0,0,1,55.15,3.756a2.539,2.539,0,0,1,1.734.662L76.341,21.636V6.373a2.617,2.617,0,0,1,5.235,0V27.438a2.6,2.6,0,0,1-1.545,2.4,2.51,2.51,0,0,1-1.072.221",
    transform: "translate(-19.452 -1.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M169.332,30.376H142.969a2.645,2.645,0,0,1-2.649-2.649,2.762,2.762,0,0,1,.347-1.324L153.88,3.54a2.632,2.632,0,0,1,3.6-.946,2.709,2.709,0,0,1,.946.946L171.6,26.4A2.624,2.624,0,0,1,170.657,30a2.234,2.234,0,0,1-1.325.378M147.51,25.141h17.281l-8.641-15.01Z",
    transform: "translate(-51.96 -0.828)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlanco);
export default __webpack_public_path__ + "static/media/logo-blanco.6f4ce0e16544b5ec8041a1a8f732da64.svg";
export { ForwardRef as ReactComponent };